import React, { useState, useEffect } from "react";
import LineItemsForm from "./LineItemsForm";
import { NameCard } from "./NameCard";
import actionPlanInvestmentService from "../../../apis/Business/ActionPlanInvestmentApi";
import "./index.css";

export const Investments = ({ effortId }) => {
  const [investments, setInvestments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (effortId) {
      fetchInvestments();
    }
  }, [effortId]);

  const fetchInvestments = async () => {
    try {
      const data = await actionPlanInvestmentService.getInvestments(effortId);
      const formattedData = data.map((item) => ({
        id: String(item.id),
        title: item.title,
        type: item.description,
        amount: item.amount,
        unit: item.currency,
      }));
      setInvestments(formattedData);
    } catch (error) {
      console.error("Error fetching investments:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (items) => {
    try {
      // Find items that need to be created, updated, or deleted
      const currentIds = new Set(investments.map((i) => i.id));
      const newIds = new Set(items.map((i) => i.id));

      // Items to create (don't exist in current investments)
      const itemsToCreate = items.filter((item) => !currentIds.has(item.id));

      // Items to update (exist in both arrays but might have changed)
      const itemsToUpdate = items.filter((item) => currentIds.has(item.id));

      // Items to delete (exist in current but not in new items)
      const itemsToDelete = investments.filter((item) => !newIds.has(item.id));

      // Process creations
      for (const item of itemsToCreate) {
        await actionPlanInvestmentService.createInvestments(effortId, {
          title: item.title,
          description: item.type,
          amount: item.amount,
          currency: item.unit,
        });
      }

      // Process updates
      for (const item of itemsToUpdate) {
        await actionPlanInvestmentService.updateInvestments(effortId, item.id, {
          title: item.title,
          description: item.type,
          amount: item.amount,
          currency: item.unit,
        });
      }

      // Process deletions
      for (const item of itemsToDelete) {
        await actionPlanInvestmentService.deleteInvestments(effortId, item.id);
      }

      // Refresh the list
      await fetchInvestments();
    } catch (error) {
      console.error("Error updating investments:", error);
    }
  };

  return (
    <div className="investments-section">
      <NameCard
        deptName="Investments"
        isBottom={false}
        className="other-effort-container"
      />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
        className="action-plans-parent-bubble"
      >
        <p
          style={{
            color: "#1B3764",
            fontSize: "14px",
            maxWidth: "700px",
          }}
        >
          Sometimes an effort takes an investment. It can be a machine or
          software or the like. Please type in the investments needed including
          the budget in this field.
        </p>
        <LineItemsForm
          initialData={investments}
          onSubmit={handleSubmit}
          showAmountFields={true}
          mode="investment"
        />
      </div>
    </div>
  );
};

export default Investments;
